export default {
      id: "baguette-usage",
      viewBox: "0 0 23 30",
      url: __webpack_public_path__ + "icons.svg#baguette",
      toString: function () {
        return this.url;
      }
    }